<div class="container">

  <div class="{{ router.url !== '/privacy' && router.url !== '/404' && !navOverlay ? 'sticky-header-bg alt' : 'sticky-header-bg' }}"></div>
  <nav role="navigation">
    <div class="header">
      <a routerLink="/" id="logo">
        <img src="/assets/logo_fill_light.png" alt="Traccio logo" class="logo">
      </a>
      <div class="spacer"></div>
      <div class="spanning-content nav" *ngIf="!(resizeService.tabletSize$ | async); else navToggle;">
        <a routerLink="/">Home</a>
        <a routerLink="/about">Overview</a>
        <a routerLink="/faq">FAQ</a>
        <a routerLink="/demo/home">Try Demo ✨</a>
        <a class="header-btn" routerLink="/signin">LOG IN</a>
        <a class="header-btn alt" routerLink="/signup">SIGN UP</a>
      </div>

      <ng-template #navToggle>
        <button *ngIf="!navOverlay; else hideOverlayButton" (click)="navOverlay=true" class="nav-toggle">
          <img class="nav-icon" src="/assets/icons/icon_nav.svg" alt="Navigation menu icon">
        </button>
        <ng-template #hideOverlayButton>
          <button (click)="navOverlay=false" class="nav-toggle">
            <img class="nav-icon" src="/assets/icons/icon_clear.svg" alt="Close navigation menu icon">
          </button>
        </ng-template>
      </ng-template>  
    </div>
    <ul class="{{navOverlay ? 'mobile-nav visible' : 'mobile-nav'}}">
      <li>
        <a role="button" (click)="navigateAway('/')">Home</a>
      </li>
      <li>
        <a role="button" (click)="navigateAway('/about')">Overview</a>
      </li>
      <li>
        <a role="button" (click)="navigateAway('/faq')">FAQ</a>
      </li>
      <li>
        <a role="button" (click)="navigateAway('/demo/home')">Try Demo ✨</a>
      </li>
      <li>
        <a class="header-btn" role="button" (click)="navigateAway('/signin')">LOG IN</a>
      </li>
      <li>
        <a class="header-btn alt" role="button" (click)="navigateAway('/signup')">SIGN UP</a>
      </li>
    </ul>
    
  </nav>
  

  <div class="page-content">
    <span id="top-marker"></span>
    <app-loading-indicator *ngIf="(loaderService.loading | async); else content"></app-loading-indicator>
    <ng-template #content>
      <router-outlet></router-outlet>
    </ng-template>
  </div>

  <footer class="landing-footer">
    <div class="footer">
      <div class="footer-item alt">
        <img src="/assets/logo_fill_light.png" alt="Traccio logo" class="logo">
        <p class="compound-text">Check out Traccio's <a href="https://github.com/Duha-H/Traccio/">open source repository</a>! <img class="inline-logo" src="/assets/icons/github_icon.png" alt="Github logo"></p>
      </div>
      <div class="spacer"></div>
      <div class="footer-item">
        <p class="heading">Links</p>
        <a routerLink="/">Home</a>
        <a routerLink="/about">Overview</a>
        <a routerLink="/faq">FAQ</a>
        <a routerLink="/signin">Log in</a>
        <a routerLink="/singup">Sign up</a>
        <a routerLink="/privacy">Privacy</a>
      </div>
      <div class="footer-item">
        <p class="heading">External Links</p>
        <a href="https://github.com/Duha-H/Traccio">Public Repository</a>
        <a href="https://github.com/Duha-H/Traccio/wiki">Application Wiki</a>
      </div>
      <div class="footer-item">
        <p class="heading">Support & Contact</p>
        <a href="https://github.com/Duha-H/Traccio/issues">Github Issue</a>
        <a href="mailto:support@traccio.app">Reach out at support@traccio.app</a>
      </div>
    </div>
    
    <small>&copy; Traccio 2020</small>
  </footer>

</div>